import {createContext, Dispatch, SetStateAction, useEffect, useState} from 'react'
import qs from 'qs'
import {ID, QueryResponseContextProps, QueryState} from './models'
import axios from 'axios'
import {brandApiRoot, brandApiUrl, brandName, brandUrl, brandWebsite, isPosHost} from '../brand'

const API_ROOT = brandApiRoot
const IMPORT_DB = process.env.REACT_APP_MEGAPAY_DB
const isPOS = process.env.REACT_APP_MEGAPAY_isPOS === 'true' || isPosHost
const isAPP = process.env.REACT_APP_MEGAPAY_isAPP === 'true' || isPOS
const onTSP = process.env.REACT_APP_MEGAPAY_onTSP === 'true'
const isOptional = process.env.REACT_APP_MEGAPAY_isOptional === 'true'
const onPremisseses = process.env.REACT_APP_MEGAPAY_onPremisseses === 'true'
const isMobile = process.env.REACT_APP_MEGAPAY_isMobile === 'true'
const isSharBankSSO = process.env.REACT_APP_MEGAPAY_isSharBankSSO === 'true'
const isOnline = process.env.REACT_APP_MEGAPAY_isOnline === 'true'
const isTSP = process.env.REACT_APP_MEGAPAY_isTSP === 'true'
const TSPType = process.env.REACT_APP_MEGAPAY_TSPType
const URL = brandUrl
const WebSite = brandWebsite
const isMegaPay = process.env.REACT_APP_MEGAPAY_isMegaPay === 'true'
const projectName = ` ${brandName} `
const externalDashboard = process.env.REACT_APP_MEGAPAY_externalDashboard === 'true'
const API_URL = brandApiUrl

const CompanyOrBuyerTypes = [
  {
    label: (
      <>
        <span className='badge text-primary fw-bolder fs-8 p-0 pe-5'>
          <i className='las la-user fs-2x text-primary me-2'></i>
          حقیقی
        </span>
      </>
    ),
    value: 1,
  },
  {
    label: (
      <span className='badge text-info fw-bolder fs-8 p-0 pe-5'>
        <i className='las la-building fs-2x text-info me-2'></i>
        حقوقی
      </span>
    ),
    value: 2,
  },
  {
    label: (
      <span className='badge text-primary fw-bolder fs-8 p-0 pe-5'>
        <i className='las la-user-friends fs-2x text-primary me-2'></i>
        مشارکت مدنی
      </span>
    ),
    value: 3,
  },
  {
    label: (
      <span className='badge text-primary fw-bolder fs-8 p-0 pe-5'>
        <i className='las la-user-tie fs-2x text-primary me-2'></i>
        اتباع غیر ایرانی
      </span>
    ),
    value: 4,
  },
]

function createResponseContext<T>(initialState: QueryResponseContextProps<T>) {
  return createContext(initialState)
}

function isNotEmpty(obj: unknown) {
  return obj !== undefined && obj !== null && obj !== ''
}

function fixZero(num: number) {
  return num && num != null && isNotEmpty(num) ? Number(Math.floor(num).toFixed(0)) : 0
}

function numberWithCommas(x: number | undefined | string) {
  try {
    const s = (x ?? '').toString().trim()
    if (!/^-?\d+(\.\d+)?$/.test(s)) return s // اگر فرمت عددی نبود
    const sign = s.startsWith('-') ? '-' : ''
    let [intPart, frac = ''] = s.replace(/^-/, '').split('.')
    frac = frac.replace(/0+$/, '') // حذف صفرهای انتهایی
    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',') // 3 رقم 3 رقم
    return sign + intPart + (frac ? '.' + frac : '')
  } catch (error) {
    return (x || '').toString()
  }
}

function PosSetting() {
  const _id = `setting_${Math.floor(Math.random() * 1254685)}`
  const iframe = document.createElement('iframe')
  iframe.id = _id
  iframe.style.display = 'none'
  iframe.srcdoc = `<html><body><script>Android.opensetting();document.getElementsByTagName("html")[0].innerHTML = ""</script></body></html>`
  document.body.appendChild(iframe)
  setTimeout(() => {
    document.getElementById(_id)?.remove()
  }, 500)
}

function AppClearCache() {
  const _id = `cache_${Math.floor(Math.random() * 1254685)}`
  const iframe = document.createElement('iframe')
  iframe.id = _id
  iframe.style.display = 'none'
  iframe.srcdoc = `<html><body><script>Android.clearCatch();document.getElementsByTagName("html")[0].innerHTML = ""</script></body></html>`
  document.body.appendChild(iframe)
  setTimeout(() => {
    document.getElementById(_id)?.remove()
  }, 500)
}

function PosPayment(amount: string, hsh: string) {
  const _id = `payment_${Math.floor(Math.random() * 1254685)}`
  const iframe = document.createElement('iframe')
  iframe.id = _id
  iframe.style.display = 'none'
  iframe.srcdoc = `<html><body><script>Android.payment(${amount},'${hsh}');document.getElementsByTagName("html")[0].innerHTML = ""</script></body></html>`
  document.body.appendChild(iframe)
  setTimeout(() => {
    document.getElementById(_id)?.remove()
  }, 500)
}

function PosPrint(img: string) {
  const _id = `print_${Math.floor(Math.random() * 1254685)}`
  const iframe = document.createElement('iframe')
  iframe.id = _id
  iframe.style.display = 'none'
  iframe.srcdoc = `<html><body><script>Android.print('${img}');document.getElementsByTagName("html")[0].innerHTML = ""</script></body></html>`
  document.body.appendChild(iframe)
  setTimeout(() => {
    document.getElementById(_id)?.remove()
  }, 500)
}

function PosBattery() {
  const _id = `battery_${Math.floor(Math.random() * 1254685)}`
  const iframe = document.createElement('iframe')
  iframe.id = _id
  iframe.style.display = 'none'
  iframe.srcdoc = `<html><body><script>const prcnt = Android.getBattery();document.getElementsByTagName("html")[0].innerHTML = prcnt</script></body></html>`
  document.body.appendChild(iframe)
  const prcnt = document.getElementById(_id)?.innerHTML
  document.getElementById(_id)?.remove()
  return Number(prcnt || '0')
}

var persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
  arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
const fixNumbers = function (str: string) {
  if (typeof str === 'string' && isNotEmpty(str)) {
    for (var i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i.toString()).replace(arabicNumbers[i], i.toString())
    }
  }
  return str
}

function isValidNationalCode(code: string) {
  code = fixNumbers(code)
  if (code.length !== 10 || /(\d)(\1){9}/.test(code)) return false

  let sum = 0,
    chars = code.split(''),
    lastDigit,
    remainder

  for (let i = 0; i < 9; i++) {
    sum += +chars[i] * (10 - i)
  }

  remainder = sum % 11
  lastDigit = remainder < 2 ? remainder : 11 - remainder
  return +chars[9] === lastDigit
}

const DEVICE_ID_KEY = 'mp:device-id'

// A random id this browser keeps for the panel. The server stores it with each sign-in to tell
// «ورود از دستگاه جدید» apart from a browser the user has used before; it identifies nothing else.
// Blocked or cleared storage only means the next sign-in counts as a new device.
function browserDeviceId(): string | undefined {
  try {
    const stored = window.localStorage.getItem(DEVICE_ID_KEY)
    if (stored && /^[A-Za-z0-9-]{16,64}$/.test(stored)) return stored
    const bytes = new Uint8Array(16)
    window.crypto.getRandomValues(bytes)
    const created = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')
    window.localStorage.setItem(DEVICE_ID_KEY, created)
    return created
  } catch {
    return undefined
  }
}

/** The kind of device a sign-in is: the server keeps at most two at a time of each kind per user (backend 1.0.0.757). */
export type AppKind = 'app' | 'pwa' | 'browser'

/**
 * «معتمد آسا» for Android ('app': its bridge window.asaApp, or its user agent's «ASATSP/<version>» mark — the same
 * checks as install-app/core/androidApp, inlined to keep the helpers free of the module), the panel installed as an
 * app from the browser ('pwa': its own window or home-screen app), or a browser tab ('browser').
 */
function currentAppKind(): AppKind {
  try {
    const asaApp = (window as Window & {asaApp?: {platform?: string}}).asaApp
    if ((asaApp && asaApp.platform === 'android') || /\bASATSP\/\d/.test(navigator.userAgent || ''))
      return 'app'
    const standalone = (navigator as Navigator & {standalone?: boolean}).standalone === true
    const displayMode =
      typeof window.matchMedia === 'function' &&
      ['standalone', 'fullscreen', 'minimal-ui', 'window-controls-overlay'].some(
        (mode) => window.matchMedia(`(display-mode: ${mode})`).matches
      )
    return standalone || displayMode ? 'pwa' : 'browser'
  } catch {
    return 'browser'
  }
}

async function GetBrowserData() {
  var nVer = navigator.appVersion
  var nAgt = navigator.userAgent
  var browserName = navigator.appName
  var fullVersion = '' + parseFloat(navigator.appVersion)
  var majorVersion = parseInt(navigator.appVersion, 10)
  var nameOffset, verOffset, ix

  // In Opera, the true version is after "OPR" or after "Version"
  if ((verOffset = nAgt.indexOf('OPR')) != -1) {
    browserName = 'Opera'
    fullVersion = nAgt.substring(verOffset + 4)
    if ((verOffset = nAgt.indexOf('Version')) != -1) fullVersion = nAgt.substring(verOffset + 8)
  }
  // In MS Edge, the true version is after "Edg" in userAgent
  else if ((verOffset = nAgt.indexOf('Edg')) != -1) {
    browserName = 'Microsoft Edge'
    fullVersion = nAgt.substring(verOffset + 4)
  }
  // In MSIE, the true version is after "MSIE" in userAgent
  else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
    browserName = 'Microsoft Internet Explorer'
    fullVersion = nAgt.substring(verOffset + 5)
  }
  // In Chrome, the true version is after "Chrome"
  else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
    browserName = 'Chrome'
    fullVersion = nAgt.substring(verOffset + 7)
  }
  // In Safari, the true version is after "Safari" or after "Version"
  else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
    browserName = 'Safari'
    fullVersion = nAgt.substring(verOffset + 7)
    if ((verOffset = nAgt.indexOf('Version')) != -1) fullVersion = nAgt.substring(verOffset + 8)
  }
  // In Firefox, the true version is after "Firefox"
  else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
    browserName = 'Firefox'
    fullVersion = nAgt.substring(verOffset + 8)
  }
  // In most other browsers, "name/version" is at the end of userAgent
  else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
    browserName = nAgt.substring(nameOffset, verOffset)
    fullVersion = nAgt.substring(verOffset + 1)
    if (browserName.toLowerCase() == browserName.toUpperCase()) {
      browserName = navigator.appName
    }
  }
  // trim the fullVersion string at semicolon/space if present
  if ((ix = fullVersion.indexOf(';')) != -1) fullVersion = fullVersion.substring(0, ix)
  if ((ix = fullVersion.indexOf(' ')) != -1) fullVersion = fullVersion.substring(0, ix)

  majorVersion = parseInt('' + fullVersion, 10)
  if (isNaN(majorVersion)) {
    fullVersion = '' + parseFloat(navigator.appVersion)
    majorVersion = parseInt(navigator.appVersion, 10)
  }

  let OS = 'Unknown OS'
  if (navigator.userAgent.indexOf('Win') != -1) OS = 'Windows'
  if (navigator.userAgent.indexOf('Mac') != -1) OS = 'Macintosh'
  if (navigator.userAgent.indexOf('Linux') != -1) OS = 'Linux'
  if (navigator.userAgent.indexOf('Android') != -1) OS = 'Android'
  if (navigator.userAgent.indexOf('like Mac') != -1) OS = 'iOS'
  if (navigator.userAgent.indexOf('iPhone') != -1) OS = 'iOS'
  if (navigator.userAgent.indexOf('iPad') != -1) OS = 'iPadOs'

  return {
    browserName: browserName,
    fullVersion: fullVersion,
    majorVersion: majorVersion,
    navigatorAppName: navigator.appName,
    navigatorUserAgent: navigator.userAgent,
    appVersion: nVer,
    //ip: ip,
    os: OS,
    deviceId: browserDeviceId(),
    appKind: currentAppKind(),
  }
}
// Example: page=1&items_per_page=10&sort=id&order=desc&search=a&filter_name=a&filter_online=false
function stringifyRequestQuery(state: QueryState): string {
  const pagination = qs.stringify(state, {filter: ['page', 'items_per_page'], skipNulls: true})
  const sortState = {...state, sort: state.sort?.toLowerCase()}
  const sort = qs.stringify(sortState, {filter: ['sort', 'order'], skipNulls: true})
  const search = isNotEmpty(state.search)
    ? qs.stringify(state, {filter: ['search'], skipNulls: true})
    : ''

  const filterAliases: {[key: string]: string} = {
    descriptionSearch: 'descriptionserach',
    buyerStatus: 'StatusInquiry',
    paymentTypes: 'paymenttype',
    productType: 'producttype',
    netPrice: 'netprice',
    netPriceCompare: 'netpricecompare',
    article6Status: 'article6status',
    sendStatus: 'sendstatus',
    fiscalMemories: 'fiscalmemory',
    entryTypes: 'entrytype',
    proformaState: 'proformastate',
    buyerResponses: 'buyerresponse',
    errorReasons: 'errorreason',
    errorSearch: 'errorsearch',
    validFromDate: 'validfromdate',
    validToDate: 'validtodate',
  }

  const filter = state.filter
    ? Object.entries(state.filter as Object)
        .filter((obj) => {
          if (Array.isArray(obj[1])) {
            return obj[1].length > 0
          }
          return isNotEmpty(obj[1])
        })
        .map(([key, value]) => {
          const filterKey = filterAliases[key] || key
          const filterValue = Array.isArray(value) ? value.join(',') : value
          return `filter_${filterKey}=${encodeURIComponent(filterValue)}`
        })
        .join('&')
    : ''
  // A proforma valid in a range may have been issued in an earlier season, so its validity days
  // search every season too.
  const invoiceDateFilterKeys = [
    'fromDate',
    'toDate',
    'saveFromDate',
    'saveToDate',
    'validFromDate',
    'validToDate',
  ]
  const hasInvoiceDateFilter = state.filter
    ? Object.entries(state.filter as Object).some(
        ([key, value]) => invoiceDateFilterKeys.includes(key) && isNotEmpty(value)
      )
    : false

  const effectiveInvoiceSeason = hasInvoiceDateFilter ? 'all' : state.invoiceSeason
  const extraData = [
    state.baseMode ? `basemode=${state.baseMode}` : '',
    effectiveInvoiceSeason ? `invoiceSeason=${encodeURIComponent(effectiveInvoiceSeason)}` : '',
  ]
    .filter((f) => f)
    .join('&')

  return [pagination, sort, search, filter, extraData].filter((f) => f).join('&')
}

function parseRequestQuery(query: string): QueryState {
  const cache: unknown = qs.parse(query)
  return cache as QueryState
}

function calculatedGroupingIsDisabled<T>(isLoading: boolean, data: Array<T> | undefined): boolean {
  if (isLoading) {
    return true
  }

  return !data || !data.length
}

function calculateIsAllDataSelected<T>(data: Array<T> | undefined, selected: Array<ID>): boolean {
  if (!data) {
    return false
  }

  return data.length > 0 && data.length === selected.length
}

function groupingOnSelect(
  id: ID,
  selected: Array<ID>,
  setSelected: Dispatch<SetStateAction<Array<ID>>>
) {
  if (!id) {
    return
  }

  if (selected.includes(id)) {
    setSelected(selected.filter((itemId) => itemId !== id))
  } else {
    const updatedSelected = [...selected]
    updatedSelected.push(id)
    setSelected(updatedSelected)
  }
}

function groupingOnSelectAll<T>(
  isAllSelected: boolean,
  setSelected: Dispatch<SetStateAction<Array<ID>>>,
  data?: Array<T & {id?: ID}>
) {
  if (isAllSelected) {
    setSelected([])
    return
  }

  if (!data || !data.length) {
    return
  }

  setSelected(data.filter((item) => item.id).map((item) => item.id))
}

// Hook
function useDebounce(value: string | undefined, delay: number) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value)
  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler)
      }
    },
    [value, delay] // Only re-call effect if value or delay changes
  )
  return debouncedValue
}

async function getExtraSetting(name: string) {
  let data: any = null
  await axios.get(`${API_URL}/auth/user/extrasetting/${name}`).then((response) => {
    data = response.data
  })
  return data
}

async function saveExtraSetting(name: string, _data: any) {
  let data: any = null
  await axios
    .post(`${API_URL}/auth/user/extrasetting`, {name: name, data: _data})
    .then((response) => {
      data = response.data
    })
  return data
}

export {
  createResponseContext,
  stringifyRequestQuery,
  parseRequestQuery,
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  groupingOnSelectAll,
  useDebounce,
  isNotEmpty,
  fixZero,
  numberWithCommas,
  GetBrowserData,
  currentAppKind,
  isValidNationalCode,
  getExtraSetting,
  saveExtraSetting,
  PosSetting,
  PosPrint,
  PosBattery,
  PosPayment,
  AppClearCache,
  API_URL,
  IMPORT_DB,
  isPOS,
  isAPP,
  onTSP,
  isOnline,
  isMobile,
  CompanyOrBuyerTypes,
  URL,
  isMegaPay,
  fixNumbers,
  WebSite,
  API_ROOT,
  isTSP,
  projectName,
  isOptional,
  onPremisseses,
  TSPType,
  isSharBankSSO,
  externalDashboard,
}
